<script setup lang="ts">
import ChangeLocale from "@/components/shared/ChangeLocale.vue";
import { useAuthStore } from "@/stores/auth";
import { useUserStore } from "@/stores/user";
import { computed } from "vue";
import useSuperAdmin from "@/components/superadmin/useSuperAdmin";
import { UserRoles } from "@/types";

const auth = useAuthStore();
const user = useUserStore();

const {showCompanySelectionModal} = useSuperAdmin()

const isBonoAdmin = computed(() => {
  const role = user.getUserRoles.find(role => role.roleName === UserRoles.BONO_SUPER_ADMIN
    || role.roleName === UserRoles.BONO_ACCOUNT_MANAGER
    || role.roleName === UserRoles.PARTNER_ADMIN
    || role.roleName === UserRoles.PARTNER_USER);

  return !!role;
})


const { logout } = auth;
</script>
<template>
  <header class="flex flex-row items-center justify-between">
    <a href="/"><img src="@/assets/logo.svg" alt="Logo" /></a>
    <div class="flex-shrink-0 flex items-center justify-between">
      <Button v-if="isBonoAdmin" icon="ri-settings-line"
              variant="link"
              @click="showCompanySelectionModal"
      />
      <ChangeLocale />
      <Button icon="ri-logout-box-r-line" @click="logout" variant="link" />
    </div>
  </header>
</template>
